import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { LoginLogout } from './login-logout.models';

@Injectable({
    providedIn: 'root'
})
export class LoginLogoutService {

    constructor(
        private cvApiService: CVApiService
    ) { 

    }

    /** Get a collection of login/logout data from API endpoint */
    public async getLoginLogout(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let url = `/api/v2/dashboards/modules/loginlogout/${encodeURIComponent(moduleKey)}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            let response = await this.cvApiService.get<LoginLogout[]>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting data for login/logout module");
            throw err;
        }
    };

    /** Get data from API endpoint for login/logout data formatted for export */
    public async getDataForExport(moduleKey: string, format: string, sort: string){
        try {
            let renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            let url = `/api/v2/dashboards/modules/loginlogout/${encodeURIComponent(moduleKey)}/export?format=${encodeURIComponent(format)}&sort=${sort}`;
            let response = await this.cvApiService.get<LoginLogout[]>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        } catch (err) {
            console.error("Failed getting data to export login/logout module");
            throw err;
        }
    }
}
